import { recipe } from "@vanilla-extract/recipes";

import { alignVariants } from "../../utils/vanilla/alignVariants";
import { spacingVariants } from "../../utils/vanilla/spacingVariants";

export const flexStyle = recipe({
  base: {
    position: "relative",
  },
  variants: {
    overflowHidden: {
      true: {
        overflow: "hidden",
      },
    },
    direction: {
      row: {
        flexDirection: "row",
      },
      "row-reverse": {
        flexDirection: "row-reverse",
      },
      column: {
        flexDirection: "column",
      },
      "column-reverse": {
        flexDirection: "column-reverse",
      },
    },
    width: {
      stretch: {
        width: "100%",
      },
    },
    inline: {
      true: {
        display: "inline-flex",
      },
      false: {
        display: "flex",
      },
    },
    justify: {
      "flex-start": {
        justifyContent: "flex-start",
      },
      "flex-end": {
        justifyContent: "flex-end",
      },
      center: {
        justifyContent: "center",
      },
      "space-between": {
        justifyContent: "space-between",
      },
      "space-around": {
        justifyContent: "space-around",
      },
      "space-evenly": {
        justifyContent: "space-evenly",
      },
    },
    align: {
      ...alignVariants("alignItems"),
    },
    padding: {
      ...spacingVariants("padding"),
    },
    wrap: {
      true: {
        flexWrap: "wrap",
      },
    },
    gap: {
      ...spacingVariants("gap"),
    },
    grow: {
      true: {
        flexGrow: 1,
      },
      false: {
        flexGrow: 0,
      },
    },
    shrink: {
      true: {
        flexShrink: 1,
      },
      false: {
        flexShrink: 0,
      },
    },
    hideWhenEmpty: {
      true: {
        selectors: {
          "&:empty": {
            display: "contents",
          },
        },
      },
    },
  },
});
